import React from 'react';
import { Box, Button, ButtonGroup, Heading, Text } from '@chakra-ui/core';

interface RoomCrashFallbackProps {
  onLeave: () => void;
  onRejoin: () => void;
}

const RoomCrashFallback = ({ onLeave, onRejoin }: RoomCrashFallbackProps) => (
  <Box p={8} shadow="md" borderWidth="1px" borderRadius="xl">
    <Heading fontSize="lg" mb={2}>
      This room hit an error.
    </Heading>
    <Text color="gray.500" mb={5}>
      Rejoin to restore the live room, or leave safely.
    </Text>
    <ButtonGroup spacing={3}>
      <Button colorScheme="purple" onClick={onRejoin}>
        Rejoin room
      </Button>
      <Button variant="outline" onClick={onLeave}>
        Leave room
      </Button>
    </ButtonGroup>
  </Box>
);

export default RoomCrashFallback;
